import React from 'react';
import PropTypes from 'prop-types';

const Icon = ({ children }) => <div className="ws-color-scheme-select__icon">{children}</div>;

Icon.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Icon;
